import { render, staticRenderFns } from "./DepartmensPositions.vue?vue&type=template&id=c96a8b6a&"
import script from "./DepartmensPositions.vue?vue&type=script&lang=js&"
export * from "./DepartmensPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports